import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import API from '../../api/axios';

export default function Login() {
  const [telephone, setTelephone] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState('');
  const [chargement, setChargement] = useState(false);
  const { connecter } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErreur('');
    setChargement(true);

    try {
      const response = await API.post('/auth/connexion', {
        telephone,
        mot_de_passe: motDePasse
      });

      const { token, utilisateur } = response.data;
      connecter(token, utilisateur);

      // Rediriger selon le rôle
     switch (utilisateur.role) {
        case 'admin': navigate('/admin'); break;
        case 'proprietaire': navigate('/proprietaire'); break;
        case 'gerant': navigate('/gerant'); break;
        case 'serveur': navigate('/serveur'); break;
        case 'caissier': navigate('/caissier'); break;
        default: navigate('/');
      }

    } catch (err) {
      setErreur(err.response?.data?.message || '❌ Erreur de connexion');
    } finally {
      setChargement(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>

        {/* Logo */}
        <div style={styles.logo}>
          <span style={styles.logoIcon}>📦</span>
          <h1 style={styles.logoText}>StockPro</h1>
          <p style={styles.logoSub}>Manager</p>
        </div>

        <h2 style={styles.titre}>Connexion</h2>
        <p style={styles.sousTitre}>Entrez vos identifiants pour accéder à votre espace</p>

        {/* Message d'erreur */}
        {erreur && (
          <div style={styles.erreur}>
            {erreur}
          </div>
        )}

        {/* Formulaire */}
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.champGroupe}>
            <label style={styles.label}>📱 Numéro de téléphone</label>
            <input
              type="tel"
              placeholder="0709000000"
              value={telephone}
              onChange={(e) => setTelephone(e.target.value)}
              style={styles.input}
              required
            />
          </div>

          <div style={styles.champGroupe}>
            <label style={styles.label}>🔒 Mot de passe</label>
            <input
              type="password"
              placeholder="••••••••"
              value={motDePasse}
              onChange={(e) => setMotDePasse(e.target.value)}
              style={styles.input}
              required
            />
          </div>

          <button
            type="submit"
            style={{
              ...styles.bouton,
              opacity: chargement ? 0.7 : 1
            }}
            disabled={chargement}
          >
            {chargement ? '⏳ Connexion...' : 'SE CONNECTER'}
          </button>
        </form>

        <p style={styles.footer}>
          StockPro Manager v1.0 — Tous droits réservés
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #1A1A2E 0%, #16213E 50%, #0F3460 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    fontFamily: "'Segoe UI', sans-serif"
  },
  card: {
    background: 'white',
    borderRadius: '20px',
    padding: '40px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
  },
  logo: {
    textAlign: 'center',
    marginBottom: '24px'
  },
  logoIcon: {
    fontSize: '48px'
  },
  logoText: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#00C853',
    margin: '0'
  },
  logoSub: {
    color: '#666',
    margin: '0',
    fontSize: '14px'
  },
  titre: {
    fontSize: '22px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    textAlign: 'center',
    margin: '0 0 8px 0'
  },
  sousTitre: {
    color: '#888',
    fontSize: '13px',
    textAlign: 'center',
    marginBottom: '24px'
  },
  erreur: {
    background: '#FFEBEE',
    color: '#C62828',
    padding: '12px 16px',
    borderRadius: '10px',
    marginBottom: '16px',
    fontSize: '14px',
    border: '1px solid #FFCDD2'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  champGroupe: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  label: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#333'
  },
  input: {
    padding: '12px 16px',
    borderRadius: '10px',
    border: '2px solid #E0E0E0',
    fontSize: '15px',
    outline: 'none',
    transition: 'border-color 0.2s',
    width: '100%',
    boxSizing: 'border-box'
  },
  bouton: {
    background: 'linear-gradient(135deg, #00C853, #2979FF)',
    color: 'white',
    border: 'none',
    padding: '14px',
    borderRadius: '10px',
    fontSize: '15px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: '8px',
    letterSpacing: '1px'
  },
  footer: {
    textAlign: 'center',
    color: '#AAA',
    fontSize: '11px',
    marginTop: '24px'
  }
};